var $525f6fa4ac26e278$exports = {};
$525f6fa4ac26e278$exports = {
  "Clear search": "\u6E05\u9664\u641C\u5C0B\u689D\u4EF6"
};
export { $525f6fa4ac26e278$exports as default };